import { connect } from 'react-redux';
import SkillView from './SkillView';
import { fetchSkills, createSkill, updateSkill } from 'src/legacy/redux/actions/skills';

import _ from 'lodash';

const mapStateToProps = (state) => ({
    skills: _.get(state.legacyRootReducer, "settings.skills.items.records") || [],
    pagination: _.get(state.legacyRootReducer, "settings.skills.items.pagination") || {},
    loading: _.get(state.legacyRootReducer, "settings.skills.loading"),
    creating: _.get(state.legacyRootReducer, "settings.skills.creating"),
    updating: _.get(state.legacyRootReducer, "settings.skills.updating")
});

const mapDispatchToProps = (dispatch) => {
    return {
        fetchSkills: (page) => {
            return dispatch(fetchSkills(page));
        },
        createSkill: (request) => {
            return dispatch(createSkill(request));
        },
        updateSkill: (id, request) => {
          return dispatch(updateSkill(id, request));
        }
    }
};

const SkillContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SkillView);

export default SkillContainer;